// extracted by mini-css-extract-plugin
export default {"wrapper":"EE-z","button":"FE-z","alternate":"GE-z","disabled":"HE-z","paymentWarning":"IE-z","fadeIn":"JE-z"};